import { render, staticRenderFns } from "./LoginDefault.vue?vue&type=template&id=52cfdaaf&lang=pug"
import script from "./LoginDefault.vue?vue&type=script&lang=js"
export * from "./LoginDefault.vue?vue&type=script&lang=js"
import style0 from "../../../assets/style/default/login-default.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports